import { useEffect, useState } from 'react';

import { useCaseGetTournamentLocations, useCaseGetTournaments } from 'application/modules';

/**
 * Custom hook to get tournaments for a location name.
 * @param locationName The name of the location to look up
 * @returns tournaments array for the found locationId, or [] if not found
 *          errors from both tournament locations and tournaments queries (separated)
 */
export const useGetTournamentsForLocation = (locationName: string | undefined) => {
  const [customLoading, setCustomLoading] = useState(!!locationName);

  const { data: locations, error: locationsError } = useCaseGetTournamentLocations();

  // Find locationId by name
  const location = locations?.find((loc: { name: string }) => loc.name === locationName);
  const locationId = location?.id;

  const {
    data: tournaments,
    error: tournamentsError,
    isLoading,
  } = useCaseGetTournaments(locationId);

  useEffect(() => {
    if (!locationName || !locationId) {
      setCustomLoading(false);
    } else {
      setCustomLoading(isLoading);
    }
  }, [isLoading, locationId, locationName]);

  // Return errors separately
  return {
    tournaments: tournaments ?? [],
    isLoading: customLoading,
    locationsError,
    tournamentsError,
  };
};
